import React, { useEffect, useState } from 'react';
import { translate } from '../../../Services/translation';
import Icon from '../../Icon';
import {
  ReturnFormActions,
  Status,
} from '../../../Reducers/ReturnForm.reducer';
import { useDispatch } from 'react-redux';
import { EditorStringModel } from '../../../Types/EditorString';
import EditorString from '../../EditorString/EditorString';

const ReturnFormSuccessContainer = ({
  confirmationText,
}: {
  confirmationText?: EditorStringModel;
}) => {
  const dispatch = useDispatch();

  return (
    <div className="col-span-2 flex flex-col items-center justify-center gap-6">
      <div
        className="btn btn--outline btn--large"
        onClick={() => {
          dispatch(
            ReturnFormActions.setReturnStatus({
              status: Status.idle,
            })
          );
          dispatch(ReturnFormActions.clearState());
        }}
      >
        {translate('general.back')}
      </div>
      <Icon name="check" className="h-20 w-20" />
      {confirmationText && <EditorString value={confirmationText.value} />}
    </div>
  );
};

export default ReturnFormSuccessContainer;
